import { useMutation } from "urql";

import { CreateCustomerRiskMonitoringRemarksDocument } from "../../../graphql/generated.ts";

export const useCreateRiskMonitoringRemarks = () =>
  useMutation(CreateCustomerRiskMonitoringRemarksDocument);
